import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineIndicationForSOSMedicineDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineIndicationForSOSMedicine/GetDetail?` + params, null);

export const GetMedicineIndicationForSOSMedicineList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineIndicationForSOSMedicine/GetList?` + params, null);

export const CreateMedicineIndicationForSOSMedicine = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineIndicationForSOSMedicine/Create`, data);

export const UpdateMedicineIndicationForSOSMedicine = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineIndicationForSOSMedicine/Update`, data);

export const DeleteMedicineIndicationForSOSMedicine = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineIndicationForSOSMedicine/Delete`, data);